var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"input",class:['date-input', { 'full-width': _vm.fullWidth }],attrs:{"type":"date","min":_vm.min},domProps:{"value":_vm.value},on:{"input":_vm.onInput,"click":_vm.openPicker}})
}
var staticRenderFns = []

export { render, staticRenderFns }